import { render, staticRenderFns } from "./dianpu_ligs.vue?vue&type=template&id=98228730&scoped=true&"
import script from "./dianpu_ligs.vue?vue&type=script&lang=js&"
export * from "./dianpu_ligs.vue?vue&type=script&lang=js&"
import style0 from "./dianpu_ligs.vue?vue&type=style&index=0&id=98228730&prod&lang=less&scoped=true&"
import style1 from "./dianpu_ligs.vue?vue&type=style&index=1&id=98228730&prod&lang=css&"
import style2 from "./dianpu_ligs.vue?vue&type=style&index=2&id=98228730&prod&lang=less&scoped=true&"
import style3 from "./dianpu_ligs.vue?vue&type=style&index=3&id=98228730&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98228730",
  null
  
)

export default component.exports